module.exports = __webpack_public_path__ + "static/switchoff-3d26f5af8275232a26ce3573db4e1e1d.png";